// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fq-6";
export var emphasizeQuantity = "_fq-3";
export var flatBottomCorners = "_fq-5";
export var productImage = "_fq-0";
export var quantityContainer = "_fq-2";
export var tooltip = "_fq-1";
export var wrapAndEllipsesOverflow = "_fq-4";